/*
  HB 2026-10-13 (Olivia): collection pages. Loaded by snippets/hb-menu-panel.liquid on every page; does nothing unless
  the page has a product grid with infinite scroll (results-list).

  1. One tap opens a product (phones and tablets). On iPhone the first tap on a card was often swallowed: Safari can
     treat the first tap as a hover when something on the card changes on :hover or on touch (the theme reveals the
     card's other image slides then), and only the second tap clicks. Here a short, still touch on a card opens the
     product at once, and the card fades a little so the tap is seen while the product page loads. Swatches, the +
     (quick add), the image arrows and any button keep their own behaviour; a swipe, a long press (the system menu) or a
     tap that stops a moving page does nothing.

  2. Back from a product lands where you were. assets/paginated-list.js keeps a record (sessionStorage
     "hb-plp-restore": the card and how far it was from the top of the screen) and restores it from the address and
     the browser's "back" report. On iPhone that was not enough (Olivia's tests, 13 and 14 October): the collection
     came back at the top of the first page.

  2026-10-14: the return no longer depends on the address or on the browser's report. Opening a product from the grid
  (a tap, or a click on desktop) marks the record as a pending return, with the card's page of the infinite scroll.
  When the same collection loads within 30 minutes with a pending return:
    - the card is on the page: the page is scrolled to it, again while the page settles (pictures, the pages above
      being added, the theme's own jump to the #), until the shopper touches or scrolls;
    - the card is not on the page (Safari came back to the address without its page number): the card's page is
      loaded in its place, once, and the same happens there.

  2026-10-14, afternoon (Olivia's iPhone test, the panel below): Safari brought the collection back from memory, but at
  the top, not where she was (the theme sets history.scrollRestoration to "manual", and Safari then leaves the scroll
  of a page it keeps in memory to the page); the script had taken "from memory" to mean "already in place" and ended
  the return, so the reload that followed started at the top too. Now:
    - a page brought back from memory is scrolled to the card like any other return;
    - the return stays open while she is back on the collection, and follows her: when she scrolls, the record moves
      to where she is (the card at 40 % of the screen, as paginated-list.js does), and it is written again as the page
      goes, after paginated-list.js's own save, so a reload, a second Back or Safari reloading the tab lands where she
      was last;
    - it ends when she opens another product (a new return), leaves by a link (the menu, the logo, the cart, another
      collection), or after 30 minutes away, so a later visit from the menu starts at the top as usual.

  HB 2026-10-15 (round 49b, record 5.97, DECISIONS 110; Vic: "first tap should open quick view (or Mini PDP as I call
  it) so please fix this. However, back button from Main PDP should go back to where user was on collection (and not
  have a Mini PDP open)"). On this theme the first tap on a card opens the quick view (assets/hb-sheet.js), so:
    - the still tap of 1. opens the quick view at once: it is handed to the sheet as the click on the card's link that
      the sheet listens for. The sheet stands back while a note is up (the gift's tile, the quick add's "Added to your
      cart") and the click then fell through to the product page; a tap is her choice, so the gift's tile is closed
      by its x and the quick view opens (over the quick add's note, which leaves on its own). Where there is no quick
      view (switched off, a tablet without the desktop quick view) or another layer is open, it opens the product as
      before;
    - a product opened from the quick view (Take me to the product, the +n colors, any other link inside it) marks
      the return with the card that opened the quick view, and the card fades while the product page loads. Links the
      sheet does not handle itself leave the way Take me to the product does: the sheet closes and its history entry
      goes first, then the page, so Back from the product page never lands on an open quick view;
    - a page brought back from memory with the quick view still open or still closing (a way out the sheet did not
      see) closes it at once, steps off its history entry, and then lands on the card like any return.
  The set builder and the silk story (the same sheet) are left as they are.

  For a test on a phone: open any page with ?hbdebug=1 and a small panel at the bottom of collection pages shows what
  happened on the way back (?hbdebug=0 turns it off; closing the tab ends it too).
*/
(function () {
  'use strict';
  if (window.__hbPlpReturn) return;
  window.__hbPlpReturn = true;
  window.HBPlpReturn = { version: '2026-10-23' };

  var KEY = 'hb-plp-restore';
  var HOP = 'hb-plp-hop';
  var MENU = 'hb-plp-menu'; // HB 2026-10-23: when a menu link was followed (a page reached that way starts at the top)
  var FRESH_MS = 30 * 60 * 1000;
  var LINE = 0.4;
  var SKIP = 'button, input, label, select, textarea, [tabindex="1"], card-swatch, [class*="swatch"], slideshow-arrows, .atc-icon-wrapper, .atc-plus-icon, .variant-popup, .variant-popup-inner, .custom-size-row, quick-add-component';

  /* ---------- the test panel (?hbdebug=1) ---------- */
  var debug = false;
  try {
    var flag = new URL(window.location.href).searchParams.get('hbdebug');
    if (flag === '1') sessionStorage.setItem('hb-debug', '1');
    if (flag === '0') sessionStorage.removeItem('hb-debug');
    debug = sessionStorage.getItem('hb-debug') === '1';
  } catch (e) {}
  // the panel keeps the last few minutes across pages (the tap on the grid, then the way back, or a page hop)
  var lines = [];
  var panel = null;
  var KEPT = 'hb-debug-lines';
  if (debug) {
    try {
      var kept = JSON.parse(sessionStorage.getItem(KEPT) || 'null');
      if (kept && kept.lines && Date.now() - kept.at < 5 * 60 * 1000) lines = kept.lines.concat(['-- ' + window.location.pathname + ' --']);
    } catch (e) {}
  }
  function log(text) {
    if (!debug) return;
    var t = (performance.now() / 1000).toFixed(1);
    lines.push(t + 's ' + text);
    while (lines.length > 16) lines.shift();
    try { sessionStorage.setItem(KEPT, JSON.stringify({ at: Date.now(), lines: lines })); } catch (e) {}
    if (!panel && document.body) {
      panel = document.createElement('div');
      panel.setAttribute('aria-hidden', 'true');
      panel.style.cssText = 'position:fixed;left:6px;right:6px;bottom:6px;z-index:2147483647;max-height:45vh;overflow:hidden;padding:6px 8px;background:rgba(255,255,255,.92);color:#2f2e2e;font:10px/1.35 ui-monospace,Menlo,monospace;border:1px solid #e6e6e6;pointer-events:none;white-space:pre-wrap;word-break:break-all';
      document.body.appendChild(panel);
    }
    if (panel) panel.textContent = lines.join('\n');
  }

  /* ---------- the record ---------- */
  var lastPending = null; // the open return as this page last wrote or used it (written again as the page goes)
  var openedAt = 0;

  function read() {
    try {
      return JSON.parse(sessionStorage.getItem(KEY) || 'null');
    } catch (e) {
      return null;
    }
  }

  function write(record) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify(record));
    } catch (e) {}
    lastPending = record && record.pending ? record : null;
  }

  function plain(href) {
    try {
      var u = new URL(href, window.location.href);
      u.searchParams.delete('page');
      u.searchParams.delete('hbdebug');
      u.searchParams.delete('pb');
      u.hash = '';
      return u.pathname + u.search;
    } catch (e) {
      return '';
    }
  }

  function cardOf(el) {
    return el && el.closest ? el.closest('[ref="cards[]"]') : null;
  }

  function withId(card) {
    var target = card;
    while (target && !target.id) target = target.nextElementSibling;
    return target;
  }

  function recordFor(target, fallbackPage) {
    return {
      key: window.location.pathname + window.location.search,
      id: target.id,
      top: Math.round(target.getBoundingClientRect().top),
      page: Number(target.getAttribute('data-page')) || fallbackPage || 1,
      t: Date.now(),
      pending: true
    };
  }

  function fade(card) {
    card.style.transition = 'opacity .2s ease';
    card.style.opacity = '.6';
  }

  /* on every page: leaving by a link (not by Back) ends the open return */
  function unmark(why) {
    lastPending = null;
    var record = read();
    if (!record || !record.pending) return;
    record.pending = false;
    write(record);
    log('return ended (' + why + ')');
  }

  function leaving() {
    // HB 2026-10-23 (Vic: "Excellent that it goes back to her old spot if she presses back, but if she goes via menu it
    // should always start from top"): a link in the header, the menus or the footer ends the open return before
    // anything else sees the click (capture), also a link the page handles itself and a link to the collection she is
    // already on, so the collection opened from the menu starts at the top. Back still lands where she was.
    window.addEventListener('click', function (e) {
      if (!e.isTrusted || e.metaKey || e.ctrlKey || e.shiftKey || !(e.target instanceof Element)) return;
      var a = e.target.closest('a[href]');
      if (!a || (a.target && a.target !== '_self')) return;
      if (!a.closest('#header-group, header, header-drawer, .menu-drawer, .hb-mpanel, footer, .shopify-section-group-footer-group')) return;
      try {
        var to = new URL(a.href, window.location.href);
        if (to.origin !== window.location.origin) return;
        if (to.hash && to.pathname === window.location.pathname && to.search === window.location.search) return;
      } catch (err) {
        return;
      }
      try { sessionStorage.setItem(MENU, String(Date.now())); } catch (err) {}
      unmark('left by the menu');
    }, true);
    window.addEventListener('click', function (e) {
      if (!e.isTrusted || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || !(e.target instanceof Element)) return;
      if (e.target.closest('results-list')) return;
      var a = e.target.closest('a[href]');
      if (!a || (a.target && a.target !== '_self')) return;
      try {
        var to = new URL(a.href, window.location.href);
        if (to.origin !== window.location.origin) return;
        if (to.pathname === window.location.pathname && to.search === window.location.search) return;
      } catch (err) {
        return;
      }
      unmark('left by a link');
    });
  }

  function start() {
    leaving();
    var list = document.querySelector('results-list');
    if (!list) return;
    log('collection ' + window.location.pathname + window.location.search + window.location.hash + ' | ' + navigationType() + (legacyBack() ? ' (legacy: back)' : ''));
    // round 49b: registered before the return's own page-show below, so the quick view is gone before it measures
    closeOnReturn();
    clicks(list);
    taps(list);
    fromQuickView(list);
    keepOnLeave(list);
    // back to a page Safari (or Chrome) kept in memory: scrolled to the card like any other return
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var faded = list.querySelectorAll('[ref="cards[]"][style*="opacity"]');
      for (var i = 0; i < faded.length; i++) faded[i].style.opacity = '';
      log('back from memory at y ' + Math.round(window.scrollY) + ' | ' + window.location.search + (window.location.hash ? ' #..' + window.location.hash.slice(-6) : ''));
      if (debug) checkCart();
      restore(list, 'memory');
    });
    restore(list, 'load');
  }

  /* the test panel only: does the bag's number still match the cart (assets/cart-icon.js reloads the page when not) */
  function checkCart() {
    try {
      var shown = document.querySelector('[ref="cartBubbleCount"]');
      var shownN = shown ? parseInt(shown.textContent || '0', 10) || 0 : '?';
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { log('cart ' + c.item_count + ', bag shows ' + shownN + (c.item_count !== shownN ? ' (cart-icon reloads)' : '')); })
        .catch(function () {});
    } catch (e) {}
  }

  /* the same record and address as assets/paginated-list.js makes on a click, plus the pending mark and the page */
  function remember(card, setAddress, how) {
    var page = Number(card.getAttribute('data-page')) || 1;
    if (setAddress) {
      var url = new URL(window.location.href);
      if (page <= 1) url.searchParams.delete('page');
      else url.searchParams.set('page', String(page));
      if (card.id) url.hash = card.id;
      try {
        history.replaceState(history.state, '', url.toString());
      } catch (e) {}
    }
    var target = withId(card);
    if (!target) return;
    var record = recordFor(target, page);
    openedAt = record.t;
    write(record);
    log('open ' + record.id.slice(-13) + ' page ' + record.page + ' top ' + record.top + ' | ' + window.location.search + ' (' + (how || (setAddress ? 'tap' : 'click')) + ')');
    try { sessionStorage.removeItem(HOP); } catch (e) {}
    // assets/paginated-list.js also saves a record on a click and as the page goes; written again after both, so the
    // pending mark and the page are not lost whichever runs last
    setTimeout(function () { write(record); }, 0);
    window.addEventListener('pagehide', function () {
      if (Date.now() - record.t < 5000) write(record);
    }, { once: true });
  }

  /* a click on a card (desktop, or a tap that reaches the page as a click): marked as a pending return too */
  function clicks(list) {
    list.addEventListener('click', function (e) {
      if (!e.isTrusted || !(e.target instanceof Element) || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
      if (e.target.closest(SKIP)) return;
      var card = cardOf(e.target);
      if (!card || !list.contains(card)) return;
      remember(card, false);
    }, true);
  }

  function taps(list) {
    if (!window.matchMedia || !window.matchMedia('(hover: none) and (pointer: coarse)').matches) return;
    var lastPageScroll = 0;
    var touch = null;
    window.addEventListener('scroll', function () { lastPageScroll = performance.now(); }, { passive: true });

    list.addEventListener('touchstart', function (e) {
      touch = null;
      if (e.touches.length !== 1) return;
      var t = e.target;
      var card = cardOf(t);
      if (!card || !list.contains(card) || t.closest(SKIP)) return;
      // a touch that stops a page still gliding after a swipe only stops it, as everywhere on the phone
      if (performance.now() - lastPageScroll < 120) return;
      var a = t.closest('a[href]');
      var link = a && card.contains(a) ? a : card.querySelector('a.product-card__link[href]') || card.querySelector('a[href*="/products/"]');
      if (!link) return;
      touch = { x: e.touches[0].clientX, y: e.touches[0].clientY, at: performance.now(), card: card, link: link, href: link.href };
    }, { passive: true });

    list.addEventListener('touchmove', function (e) {
      if (!touch) return;
      var p = e.touches[0];
      if (Math.abs(p.clientX - touch.x) > 10 || Math.abs(p.clientY - touch.y) > 10) touch = null;
    }, { passive: true });

    list.addEventListener('touchcancel', function () { touch = null; }, { passive: true });

    list.addEventListener('touchend', function (e) {
      var s = touch;
      touch = null;
      if (!s || e.touches.length) return;
      if (performance.now() - s.at > 500) return;
      var p = e.changedTouches[0];
      if (Math.abs(p.clientX - s.x) > 10 || Math.abs(p.clientY - s.y) > 10) return;
      e.preventDefault();
      // round 49b: the quick view first; a tap it does not take opens the product, as before
      var took = toQuickView(s);
      if (took === 'sheet') return;
      if (took === 'none' && overNote(s)) return;
      // the theme's own click (the link's native step, a stopped event) is already on its way to the product
      if (took === 'link') {
        remember(s.card, true);
        fade(s.card);
        return;
      }
      remember(s.card, true);
      fade(s.card);
      window.location.href = s.href;
    }, { passive: false });
  }

  /* round 49b: the tap goes to assets/hb-sheet.js as the click on the card's link that it listens for on the document.
     It answers 'sheet' when the quick view took it, 'none' when the click reached the window untaken (stopped here, the
     caller opens the product) and 'link' when something stopped the click without taking it (the link then follows).
     On the way it passes assets/paginated-list.js and the card's own script like a real click. */
  function toQuickView(s) {
    var ev;
    try {
      ev = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
    } catch (err) {
      return 'none';
    }
    var reached = false;
    function last(x) {
      if (x !== ev) return;
      reached = true;
      x.preventDefault();
    }
    window.addEventListener('click', last);
    try {
      s.link.dispatchEvent(ev);
    } catch (err) {
      reached = true;
    }
    window.removeEventListener('click', last);
    if (reached) return 'none';
    if (!ev.defaultPrevented) return 'link';
    var S = window.HBSheet && window.HBSheet.state;
    log('quick view (tap) ' + (s.card.id || '').slice(-13) + (S && S.open ? '' : ', taken but not open'));
    return 'sheet';
  }

  /* round 49b: the sheet did not take the tap because a note is up (assets/hb-sheet.js blocked()): the gift's tile goes
     by its own x and the quick view opens as the sheet itself opens it from a card. Not over the cart, the gift's
     slide-up, the quick add's sizes or the code gift's toast, and only where the quick view is on for this width. */
  function overNote(s) {
    var H = window.HBSheet;
    var d = document.querySelector('dialog.hb-sl');
    if (!H || !d || typeof H.openQuickView !== 'function' || !H.state || H.state.open) return false;
    if (d.dataset.qv !== '1' || (window.innerWidth >= 750 && d.dataset.desktop !== '1')) return false;
    if (!document.querySelector('.hb-tg-note.is-in, .hb-toast.is-in') && !document.documentElement.classList.contains('hb-qa-busy')) return false;
    if (document.querySelector('cart-drawer-component dialog[open], dialog.hb-tg-dlg[open], .variant-popup.active, #freeGiftToast.is-visible')) return false;
    var pc = s.link.closest('product-card') || s.card.querySelector('product-card');
    if (!pc || pc.hasAttribute('data-no-navigation') || pc.hasAttribute('data-placeholder')) return false;
    var link = pc.querySelector('.product-card__link');
    if (!link || !link.getAttribute('href')) return false;
    var url;
    try {
      url = new URL(link.href, window.location.href);
    } catch (err) {
      return false;
    }
    var m = url.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return false;
    var x = document.querySelector('.hb-tg-note.is-in [data-tg-note-x]');
    if (x) x.click();
    try {
      H.openQuickView(decodeURIComponent(m[1]), url.pathname + url.search, pc, link);
    } catch (err) {
      return false;
    }
    log('quick view (tap, over a note) ' + (s.card.id || '').slice(-13));
    return !!H.state.open;
  }

  /* round 49b: a product opened from the quick view returns to the card that opened it. Take me to the product is
     marked on the document before the sheet's own handler, which then leaves its way (its history entry first, then
     the page). Any other link inside it is looked at after every handler: what the sheet handles itself (the colour
     dots, which swap the product inside the quick view, and whatever comes to swap in like them) is left alone; a link
     nobody took (the +n colors, a link in its info) leaves the way Take me to the product does. */
  function fromQuickView(list) {
    function context(e) {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1 || !(e.target instanceof Element)) return null;
      var H = window.HBSheet;
      var S = H && H.state;
      if (!S || !S.open || S.mode !== 'product' || !S.card) return null;
      if (!e.target.closest('dialog.hb-sl')) return null;
      var a = e.target.closest('a[href]');
      if (!a || (a.target && a.target !== '_self')) return null;
      var to;
      try {
        to = new URL(a.href, window.location.href);
      } catch (err) {
        return null;
      }
      if (to.origin !== window.location.origin || (to.pathname === window.location.pathname && to.search === window.location.search)) return null;
      return { H: H, S: S, a: a, to: to };
    }
    function mark(c, how) {
      var card = cardOf(c.S.card);
      if (!card || !list.contains(card)) return;
      remember(card, false, how);
      fade(card);
    }
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      var c = context(e);
      if (c && c.a.hasAttribute('data-hb-qv-to')) mark(c, 'from the quick view');
    }, true);
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      var c = context(e);
      if (!c || c.a.hasAttribute('data-hb-qv-to')) return;
      mark(c, 'from the quick view, a link');
      e.preventDefault();
      if (c.S.hist && typeof c.H.close === 'function') {
        c.S.navTo = c.to.href;
        c.H.close();
      } else {
        try { c.H.close(true); } catch (err) {}
        window.location.href = c.to.href;
      }
    });
  }

  /* round 49b: back from memory with the quick view still open or still closing: it goes at once (close() lets it
     slide away, which a page coming back must not show), and the page steps off the sheet's history entry. */
  function closeOnReturn() {
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var H = window.HBSheet;
      var S = H && H.state;
      var d = document.querySelector('dialog.hb-sl');
      if (!S || !d || S.mode !== 'product') return;
      if (!S.open && !d.open) return;
      var onEntry = !!(S.open && history.state && history.state.hbSheet);
      if (S.open) {
        S.navTo = null;
        try { H.close(true); } catch (err) {}
      }
      d.classList.remove('is-open');
      try {
        if (d.open) d.close();
      } catch (err) {}
      document.documentElement.classList.remove('hb-sl-lock');
      var body = document.body;
      if (body && body.style.position === 'fixed') {
        var y = -parseInt(body.style.top || '0', 10) || 0;
        body.style.width = '';
        body.style.position = '';
        body.style.top = '';
        // at once, as the sheet itself does (the site scrolls smoothly otherwise)
        try {
          window.scrollTo({ top: y, behavior: 'instant' });
        } catch (err) {
          window.scrollTo(0, y);
        }
      }
      log('quick view closed on the way back' + (onEntry ? ', off its history entry' : ''));
      if (onEntry) {
        try { history.back(); } catch (err) {}
      }
    });
  }

  /* ---------- the open return follows her on the collection ---------- */
  function cardAtLine(list) {
    var cards = list.querySelectorAll('[ref="cards[]"]');
    var line = window.innerHeight * LINE;
    var low = 0;
    var high = cards.length - 1;
    var found = null;
    while (low <= high) {
      var mid = (low + high) >> 1;
      if (cards[mid].getBoundingClientRect().bottom > line) {
        found = cards[mid];
        high = mid - 1;
      } else {
        low = mid + 1;
      }
    }
    return found;
  }

  var following = false;
  function saveHere(list) {
    if (!lastPending || Date.now() - openedAt < 5000) return;
    var card = cardAtLine(list);
    var target = card && withId(card);
    if (!target) return;
    write(recordFor(target, lastPending.page));
  }

  function follow(list) {
    if (following) return;
    following = true;
    var timer = 0;
    window.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () { saveHere(list); }, 300);
    }, { passive: true });
  }

  // As the page goes (a reload, Back, a product opened), the open return is written again. Registered once the grid's
  // element is defined (its connectedCallback has then added assets/paginated-list.js's own page-hide save, which drops
  // the pending mark), so this one runs after it and is the last word; a card just opened is written after this by
  // remember().
  function keepOnLeave(list) {
    function add() {
      window.addEventListener('pagehide', function () {
        log('page hide at y ' + Math.round(window.scrollY) + ' | ' + window.location.search + (window.location.hash ? ' #..' + window.location.hash.slice(-6) : ''));
        if (!lastPending) return;
        if (following && Date.now() - openedAt >= 5000) saveHere(list);
        else write(lastPending);
      });
    }
    try {
      customElements.whenDefined(list.localName).then(function () { setTimeout(add, 0); });
    } catch (e) {
      window.addEventListener('load', function () { setTimeout(add, 0); }, { once: true });
    }
  }

  function navigationType() {
    try {
      var entry = performance.getEntriesByType('navigation')[0];
      if (entry && entry.type) return entry.type;
    } catch (e) {}
    return 'navigate';
  }

  function legacyBack() {
    try {
      return !!(performance.navigation && performance.navigation.type === 2);
    } catch (e) {
      return false;
    }
  }

  /* how: 'load' (the page loaded) or 'memory' (the browser brought the page back as it was) */
  function restore(list, how) {
    var record = read();
    if (!record || !record.id) { log('no record'); return; }

    var age = record.t ? Math.round((Date.now() - record.t) / 1000) : null;
    var pending = !!(record.pending && record.t && Date.now() - record.t < FRESH_MS);
    var type = how === 'memory' ? 'back_forward' : navigationType();
    // HB 2026-10-23: reached from the menu (a link to this very collection can count as a reload): the top, as Vic asked
    var menuAt = 0;
    try { menuAt = Number(sessionStorage.getItem(MENU)) || 0; sessionStorage.removeItem(MENU); } catch (e) {}
    if (menuAt && Date.now() - menuAt < 15000 && type !== 'back_forward' && !legacyBack()) { log('from the menu: the top'); return; }
    log('record ' + record.id.slice(-13) + ' page ' + (record.page || '?') + ' top ' + record.top + (age != null ? ' age ' + age + 's' : '') + (pending ? ' pending' : ''));
    if (how === 'memory' && !pending) { log('not a return'); return; }
    if (!pending && type !== 'back_forward' && type !== 'reload' && !legacyBack()) { log('not a return'); return; }
    if (plain(record.key) !== plain(window.location.href)) { log('other collection: ' + plain(record.key)); return; }

    var el = document.getElementById(record.id);
    if (!el && window.location.hash) {
      try {
        el = document.getElementById(decodeURIComponent(window.location.hash.slice(1)));
      } catch (e) {}
    }
    if (!el || !list.contains(el)) {
      var want = Number(record.page) || 1;
      var have = Number(new URL(window.location.href).searchParams.get('page')) || 1;
      var hopAt = 0;
      try { hopAt = Number(sessionStorage.getItem(HOP)) || 0; } catch (e) {}
      log('card not on this page (address page ' + have + ', card page ' + want + ')');
      if (pending && want !== have && Date.now() - hopAt > 15000) {
        try { sessionStorage.setItem(HOP, String(Date.now())); } catch (e) {}
        var url = new URL(window.location.href);
        if (want <= 1) url.searchParams.delete('page');
        else url.searchParams.set('page', String(want));
        url.hash = record.id;
        lastPending = record;
        // written again as this page goes, after paginated-list.js's own save (whether or not its element is up yet)
        window.addEventListener('pagehide', function () { write(record); }, { once: true });
        try {
          customElements.whenDefined(list.localName).then(function () {
            window.addEventListener('pagehide', function () { write(record); }, { once: true });
          });
        } catch (e) {}
        log('loading page ' + want);
        window.location.replace(url.toString());
      }
      return;
    }
    try { sessionStorage.removeItem(HOP); } catch (e) {}

    var card = cardOf(el) || el;
    var top = typeof record.top === 'number' ? record.top : Math.max(80, (window.innerHeight - card.getBoundingClientRect().height) / 2);
    // the return stays open while she is here (see follow and keepOnLeave)
    if (pending) lastPending = record;

    var root = document.documentElement;
    var stopped = false;
    var userEvents = ['touchstart', 'touchmove', 'wheel', 'keydown', 'mousedown'];
    function stop(reason) {
      if (stopped) return;
      stopped = true;
      root.style.removeProperty('scroll-behavior');
      for (var i = 0; i < userEvents.length; i++) window.removeEventListener(userEvents[i], onUser, true);
      log('done (' + reason + ') y ' + Math.round(window.scrollY) + ', card at ' + Math.round(card.getBoundingClientRect().top) + ' (wanted ' + top + ')');
      if (pending) follow(list);
    }
    function onUser() { stop('shopper moved'); }
    for (var i = 0; i < userEvents.length; i++) window.addEventListener(userEvents[i], onUser, { capture: true, passive: true });

    // the site scrolls smoothly; a return should land, not glide
    root.style.setProperty('scroll-behavior', 'auto', 'important');
    function apply(when) {
      if (stopped || !card.isConnected) return;
      var y = Math.max(0, Math.round(card.getBoundingClientRect().top + window.scrollY - top));
      if (Math.abs(window.scrollY - y) > 2) {
        window.scrollTo(0, y);
        log('scroll ' + when + ': to ' + y + ', now ' + Math.round(window.scrollY));
      }
    }
    apply('start');
    requestAnimationFrame(function () { apply('frame'); });
    var times = [60, 150, 300, 600, 1000, 1600, 2400, 3200, 4200];
    for (var j = 0; j < times.length; j++) {
      (function (ms) { setTimeout(function () { apply(ms + 'ms'); }, ms); })(times[j]);
    }
    if (how === 'load') {
      window.addEventListener('load', function () { apply('load'); setTimeout(function () { apply('load+120ms'); }, 120); }, { once: true });
    }
    setTimeout(function () { stop('time'); }, how === 'memory' ? 2500 : 5000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
